function esc(s: string): string {
  return s.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');
}
function foldLine(s: string): string {
  const max = 70;
  let out = '';
  for (let i = 0; i < s.length; i += max) out += (i === 0 ? '' : '\r\n ') + s.slice(i, i + max);
  return out;
}

function toIcsLocalDate(yyyy_mm_dd: string) {
  return yyyy_mm_dd.replaceAll('-', '');
}
function toIcsLocalDateTime(isoLocal: string) {
  // Expect YYYY-MM-DDTHH:mm[:ss]
  const [d, t] = isoLocal.split('T');
  const cleanT = (t || '00:00:00').replace(/:/g, '');
  return `${toIcsLocalDate(d)}T${cleanT.length === 4 ? `${cleanT}00` : cleanT}`;
}

export function buildICS(ev: {
  uid: string;
  title: string;
  start: string;      // local ISO with time OR date-only+"T00:00:00"
  end?: string;       // local ISO with time OR date-only+"T00:00:00"
  location?: string;
  url?: string;
  description?: string;
}) {
  const isAllDay = ev.start.endsWith('T00:00:00') && (!ev.end || ev.end.endsWith('T00:00:00'));
  const lines: string[] = [];
  lines.push('BEGIN:VCALENDAR');
  lines.push('VERSION:2.0');
  lines.push('PRODID:-//MyEvents//EN');
  lines.push('CALSCALE:GREGORIAN');
  lines.push('METHOD:PUBLISH');
  lines.push('BEGIN:VEVENT');
  lines.push('UID:' + esc(ev.uid));
  const dtStamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  lines.push('DTSTAMP:' + dtStamp);

  if (isAllDay) {
    lines.push('DTSTART;VALUE=DATE:' + toIcsLocalDate(ev.start.slice(0, 10)));
    if (ev.end) {
      // ICS all-day DTEND is non-inclusive: +1 day
      const end = new Date(ev.end.slice(0, 10) + 'T00:00:00');
      const plus1 = new Date(end.getTime() + 86400000).toISOString().slice(0, 10).replaceAll('-', '');
      lines.push('DTEND;VALUE=DATE:' + plus1);
    }
  } else {
    lines.push('DTSTART:' + toIcsLocalDateTime(ev.start));
    if (ev.end) lines.push('DTEND:' + toIcsLocalDateTime(ev.end));
  }

  lines.push('SUMMARY:' + foldLine(esc(ev.title)));
  if (ev.location) lines.push('LOCATION:' + foldLine(esc(ev.location)));
  if (ev.url) lines.push('URL:' + esc(ev.url));
  if (ev.description) lines.push('DESCRIPTION:' + foldLine(esc(ev.description)));
  lines.push('END:VEVENT');
  lines.push('END:VCALENDAR');
  return lines.join('\r\n');
}

export function downloadICS(filename: string, content: string) {
  const blob = new Blob([content], { type: 'text/calendar' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.ics') ? filename : `${filename}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
